export const isValidTime = (t: string) => /^\d{2}:\d{2}$/.test(t);
